import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import MajorForm from './MajorForm';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core';
import StaticRelationList from '../../components/StaticRelationList';
import RelationUpdateTabs from '../../components/RelationUpdateTabs';
import ModelAssetList from '../asset/ModelAssetList';
import * as validatorActions from '../../components/validator/store/actions';
import TabPanelButtons from '../../components/TabPanelButtons';
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Major extends Component {
    state = {
        current_tab: 0,
        major_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false
    }

    constructor(props) {
        super(props);

        const major_id = this.props.match.params.major_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            major_id: major_id,
            view_type: view_type,
        }
        this.props.updateMajorLoaded(false);
        if (view_type !== 'create') {
            this.props.getMajorData(major_id);
        } else {
            this.props.updateMajorLoaded(true);
            this.props.getAllCourses();
            this.props.getAllCompanies();
        }

        const validationList = [
            {
                field_name: 'MajorName', functionName: ['checkRequiredFilled']
            }
        ]

        this.props.startValidator(validationList)
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleSubmit = () => {
        const auth_id = this.props.auth.user.data.auth_id;
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.saveMajor(this.props.currentMajor, this.props.currentMajorCourseList, this.props.currentMajorCompanyList, auth_id);
                    this.props.history.push('/major/list');
                    break;
                }

            case ("edit"):
                {
                    this.props.saveMajor(this.props.currentMajor, this.props.currentMajorCourseList, this.props.currentMajorCompanyList, auth_id)
                    this.props.history.push('/major/list');
                    break;
                }

            default:
                { }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteMajor(this.props.currentMajor.major_id);
                    this.props.history.push('/major/list');
                    break;
                }

            default:
                { }
        }
    }

    handleCourseSearchChange = (e) => {
        this.setState({
            leftSearch: e.target.value
        })
    }

    handleMajorCompanySearch = (e) => {
        this.setState({
            companySearch: e.target.value
        })
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, theme, currentMajor, currentMajorCourseList, currentMajorCompanyList, allCourses, allCompanies, isMajorLoaded } = this.props;

        const currentCourseTab = currentMajorCourseList.map(c => {
            return (
                { label: c.CourseName, id: c.course_id, display_order: c.display_order }
            )
        })

        const addCourseTabData = allCourses.map(c => {
            return (
                { label: c.CourseName, id: c.course_id }
            )
        })

        const currentCompanyTab = currentMajorCompanyList.map(c => {
            return (
                { label: c.CompanyName, id: c.company_id }
            )
        })

        const addCompanyTabData = allCompanies.map(c => {
            return (
                { label: c.CompanyName, id: c.company_id }
            )
        })
        switch (current_tab) {
            case (0):
                {
                    return (
                        <MajorForm
                            view_type={view_type}
                        />
                    )
                }
            case (1):
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={currentCourseTab}
                                        header={'Courses'}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={currentCompanyTab}
                                        header={'Majors'}
                                    />
                                </Grid>
                            </Grid>
                            :
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <RelationUpdateTabs
                                        currentRelationsTabData={currentCourseTab}
                                        handleDelete={this.props.toggleCourse}
                                        handleAdd={this.props.toggleCourse}
                                        availableObjectList={addCourseTabData}
                                        handleSearchChange={this.handleCourseSearchChange}
                                        leftHeader="Current Courses"
                                        rightHeader="Available Courses"
                                        classes={classes}
                                        search={this.state.courseSearch}
                                        view_type={this.props.view_type}
                                        rootClass={classes.root}
                                        dir={theme.direction}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <RelationUpdateTabs
                                        currentRelationsTabData={currentCompanyTab}
                                        handleDelete={this.props.toggleCompany}
                                        handleAdd={this.props.toggleCompany}
                                        availableObjectList={addCompanyTabData}
                                        handleSearchChange={this.handleCompaniesSearchChange}
                                        leftHeader="Current Companies"
                                        rightHeader="Available Companies"
                                        classes={classes}
                                        search={this.state.companySearch}
                                        view_type={this.props.view_type}
                                        rootClass={classes.root}
                                        dir={theme.direction}
                                    />
                                </Grid>
                            </Grid>
                    )
                }
            case (2):
                {
                    return (
                        <ModelAssetList
                            model_type='major'
                            model_id={this.props.currentMajor.major_id}
                            file_type="Major File"
                            assetList={this.props.currentMajor.assetList}
                            getAssetList={this.props.getMajorAssetList}
                            view_type={view_type}
                            updateAssetNameFunc={this.props.updateAssetName}
                        />
                    )
                }
        }
    }

    getDeleteDialog = (active, major) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Delete {major.MajorName}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Delete
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    render() {
        const { classes, currentMajor, isMajorLoaded } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentMajor)

        if (!isMajorLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isMajorLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name = {currentMajor.MajorName}
                        component_type = {"major"}
                        view_type      = {view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%' }}>
                        <Grid container>
                                <Tabs
                                    value={current_tab}
                                    onChange={this.handleChangeTab}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    classes={{
                                        root: classes.tabsRoot
                                    }}
                                    scrollable={true}
                                >
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Detail"
                                    />
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Relation"
                                    />
                                    <Tab
                                        classes={{
                                            root: classes.tabRoot
                                        }}
                                        label="Asset"
                                        // disabled={view_type === 'create'}
                                    />
                                </Tabs>
                                <TabPanelButtons
                                    component_name = {"major"}
                                    view_type      = {view_type}
                                    button_list    = {[
                                        {
                                            display:  "Save",
                                            type:     view_type === 'create' ? 'create' : 'update',
                                            onClick:  this.handleSubmit,
                                            disabled: this.disableSave(),
                                        },
                                        {
                                            type:    "delete",
                                            onClick: this.handleDeleteDialogOpen
                                        },
                                        {
                                            type:    "back",
                                            onClick: this.props.history.goBack,
                                        }
                                    ]}
                                />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {delete_dialog}
                            {page_content}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMajor:          Actions.getMajor,
        updateMajorLoaded: Actions.updateMajorLoaded,
        getMajorData:      Actions.getMajorData,
        deleteMajor:       Actions.deleteMajor,
        saveMajor:         Actions.saveMajor,
        updateMajorForm:   Actions.updateMajorForm,
        toggleCourse:      Actions.toggleCourse,
        toggleCompany:     Actions.toggleCompany,
        getMajorAssetList: Actions.getMajorAssetList,
        getAllCompanies:   Actions.getAllCompanies,
        getAllCourses:     Actions.getAllCourses,
        startValidator:    validatorActions.startValidator,
        updateAssetName:   Actions.updateAssetName
    }, dispatch);
}

function mapStateToProps({ majorApp, auth, validator }) {
    return {
        currentMajor:            majorApp.majors.currentMajor,
        allCourses:              majorApp.majors.allCourses,
        allCompanies:            majorApp.majors.allCompanies,
        currentMajorCourseList:  majorApp.majors.currentMajorCourseList,
        currentMajorCompanyList: majorApp.majors.currentMajorCompanyList,
        isMajorLoaded:           majorApp.majors.isMajorLoaded,
        validator:               validator.list,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Major)));



// WEBPACK FOOTER //
// src/main/content/major/Major.js